import { render, staticRenderFns } from "./FileEditForm.vue?vue&type=template&id=34f2fd86&"
import script from "./FileEditForm.vue?vue&type=script&lang=js&"
export * from "./FileEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports